import { BOARD_TYPE, ImasterSet } from '../../src/typings/boardType';

export const masterHomeSet = {
  typeName: BOARD_TYPE.HOME,
  path: 'home',
};
export const masterSet: ImasterSet = {
  boardSet: [
    { typeName: BOARD_TYPE.POSTING, path: 'posting' },
    { typeName: BOARD_TYPE.POSTING, path: 'posting2' },
    { typeName: BOARD_TYPE.PHOTOCARD, path: 'photocard' },
    { typeName: BOARD_TYPE.TIMELINE, path: 'timeline' },
    { typeName: BOARD_TYPE.HISTORY, path: 'history' },
    { typeName: BOARD_TYPE.GALLERY, path: 'gallery' },
    { typeName: BOARD_TYPE.MEMO, path: 'memo' },
  ],
  cursorCustom: true,
  backgroundEffect: false,
  commentMode: {
    battle: false,
  },
  widget: {
    ddayWidget: true,
    currentBoardWidget: false,
  },
  postingThemeSet: true,
  photocardPosting: false,
  challenge: false,
  soundEffect: false,
  photocardThemeSet: false,
  stickerDoc: false,
  gatePage: true,
  shootingStar: false,
  themeManager: true,
  calendarSticker: false,
  chat: false,
  simeji: false,
  status: false,
  photocardHistory: false,
  petSystem: false,
};
